import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 合算制度利用申出（1回目）参照API
import {
  IAPI_RET002_Request,
  IAPI_RET002_Response,
} from "../../../type/apiType";

// 合算制度利用申出（1回目）参照
// API仕様書_退職者
const httpAPI_RET002 = async (
  param: IAPI_RET002_Request
): Promise<IAPI_RET002_Response> => {
  let res = await http.post(ApiUrl.API_RET002, {
    ...param,
  });

  return res.data;
};

export { httpAPI_RET002 };
